module.exports = __webpack_public_path__ + "static/media/upgrade.2ffb62aa.svg";